export default {
    $get: ['ModalService', '$filter', '$state', 'state_plugin_config', function (ModalService, $filter, $state, statePluginConfig) {
        var quoteTimeout = function quoteTimeout() {
            ModalService.showError($filter('translate')('platform.base.DefaultErrorHandlerService.Session Timeout'), $filter('translate')('platform.base.DefaultErrorHandlerService.Sorry, your session has timed out. Please restart your quote.')).result.then(function () {
                $state.transitionTo(statePluginConfig.home);
            });
        };

        return {
            getErrorHandlerForCode: function getErrorHandlerForCode(errorCode) {
                switch (errorCode) {
                    case -33004:
                        return quoteTimeout;
                    default:
                        return null;
                }
            }
        };
    }]
};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/base/DefaultErrorHandlerService.js
// module id = 1023
// module chunks = 0